import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../../auth/PlatformAuthContext';
import { PORTALS } from '../../config/systems';
import { isLiveApi } from '../../services/api';

export default function PlatformLogin() {
  const { login } = usePlatformAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const showDevHint = !isLiveApi() || window.location.hostname === 'localhost';

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.toLowerCase().trim(), password);
      const dest = location.state?.from || '/platform/dashboard';
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/hcen_logo.png" alt="HCEN" className="login-logo" />
        <h1>HCEN Platform Admin</h1>
        <p className="login-tag">HCEN company — onboard & monitor hospitals</p>
        <p className="hint">Stay signed in for 1 year — no frequent session expiry.</p>
        <p className="login-note">
          <strong>NOT</strong> hospital staff login. Not {PORTALS.OP.adminDomain}. Staff use{' '}
          <Link to="/login">/login</Link>.
        </p>
        {!isLiveApi() && <div className="error">API not connected. Rebuild and upload to S3.</div>}
        <form onSubmit={submit} className="login-form">
          <label>HCEN owner email</label>
          <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@networks.hcen.in" autoComplete="username" />
          <label>Password</label>
          <input className="input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary btn-block" disabled={loading || !isLiveApi()}>
            {loading ? 'Signing in…' : 'Platform admin sign in'}
          </button>
        </form>
        {showDevHint && (
          <div className="card mt" style={{ padding: '12px', background: '#f0f9ff' }}>
            <p className="hint" style={{ margin: 0 }}><strong>After seed (dev only):</strong></p>
            <p className="hint">admin@networks.hcen.in / demo123</p>
            <p className="hint">URL: <strong>networks.hcen.in/platform/login</strong></p>
          </div>
        )}
      </div>
    </div>
  );
}
